import { Url } from '../models/Url';

export const normalizeUrl = (response: any): Url => {
    return {
        externalUrl: response?.external_url ? response.external_url : null,
        canonicalUrl: response?.canonical_url ? response.canonical_url : null,
        publicUrlDesktop: response?.public_url_desktop ? response.public_url_desktop : null,
        publicUrlMobile: response?.public_url_mobile ? response.public_url_mobile : null,
        publicUrlAmp: response?.public_url_amp ? response.public_url_amp : null,
    };
};
